import { render, staticRenderFns } from "./CarsSlider.vue?vue&type=template&id=6ab536fc&scoped=true"
import script from "./CarsSlider.vue?vue&type=script&lang=js"
export * from "./CarsSlider.vue?vue&type=script&lang=js"
import style0 from "./CarsSlider.vue?vue&type=style&index=0&id=6ab536fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab536fc",
  null
  
)

export default component.exports